import React, { useEffect, useState } from "react"
import { Select, Spin } from "antd"
import DropdownService from "src/services/DropdownService"

const SelectPackage = ({
  value,
  onChange,
  placeholder = "Chọn gói cước",
  className,
  disabled = false,
  style = { height: "36px" },
  paramsPackageList,
  listAll = false,
  setSupplierID,
}) => {
  const [packages, setPackages] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!listAll && !paramsPackageList?.networkId) return

    let params = {}
    if (paramsPackageList) {
      params = {
        network_carrier_id: paramsPackageList.networkId,
        service_type: paramsPackageList.scope,
        sim_type: paramsPackageList.simType,
        type_sim : paramsPackageList.typeSim
      }
    }

    const fetchPackages = async () => {
      setLoading(true)
      try {
        const res = await DropdownService.getListAllPackage(params)
        const result = (res?.success || []).map(pkg => ({
          label: pkg.name,
          value: pkg.ID,
          supplier_id: pkg.supplier_id,
          priceFormatted: Number(pkg.price).toLocaleString() || "0",
        }))
        setPackages(result)
      } catch (error) {
        console.error("Lỗi khi tải gói cước:", error)
        setPackages([])
      } finally {
        setLoading(false)
      }
    }

    fetchPackages()
  }, [paramsPackageList, listAll])

  const handleChange = (selectedValue, option) => {
    onChange?.(selectedValue, option)   // 👈 trả ra cả option
    setSupplierID?.(option?.supplier_id || null)
  }

  return (
    <Select
      allowClear
      showSearch
      loading={loading}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      className={className}
      disabled={disabled || loading}
      optionFilterProp="label"
      filterOption={(input, option) =>
        option?.label?.toLowerCase().includes(input.toLowerCase())
      }
      style={style}
      options={packages}
      notFoundContent={loading ? <Spin size="small" /> : null}
    />
  )
}

export default SelectPackage
